module.exports = __webpack_public_path__ + "static/media/logo.39bec957.png";